import { Component, Inject, Input, OnInit } from '@angular/core';
import { ModalService } from 'src/app/services/modal.service';
import {
  AbstractScanner,
  APP_SCANNER,
} from 'src/app/services/scanner/scanner.types';
import { OrderItemConfirmationScannerPageState } from './order-confirmation-scanner.types';
import {
  catchError,
  filter,
  mergeMap,
  switchMap,
  take,
  tap,
  throwError,
} from 'rxjs';
import { OrderService } from 'src/app/services/order.service';

@Component({
  selector: 'app-order-confirmation-scanner',
  templateUrl: './order-confirmation-scanner.component.html',
  styleUrls: ['./order-confirmation-scanner.component.scss'],
})
export class OrderConfirmationScannerComponent implements OnInit {
  @Input() public barcodeToMatch!: string;

  public pageState: OrderItemConfirmationScannerPageState =
    OrderItemConfirmationScannerPageState.SCANNING;

  public readonly pageStates = OrderItemConfirmationScannerPageState;

  constructor(
    @Inject(APP_SCANNER) private readonly scannerService: AbstractScanner,
    private readonly modalService: ModalService,
    private readonly orderService: OrderService
  ) {}

  ngOnInit() {
    this.subscribeForValueScanning();
  }

  onCloseModal(): void {
    this.modalService.dismiss();
  }

  onTryAgainClick(): void {
    this.pageState = this.pageStates.SCANNING;
  }

  onFinishClick(): void {
    this.modalService.dismiss(true);
  }

  private subscribeForValueScanning(): void {
    this.scannerService.valueScanned
      .pipe(
        tap(() => {
          this.pageState = this.pageStates.CHECKING;
        }),
        tap((scannedBarcode) => {
          if (scannedBarcode !== this.barcodeToMatch) {
            this.pageState = this.pageStates.WRONG_BARCODE;
          }
        }),
        filter((scannedBarcode) => scannedBarcode === this.barcodeToMatch),
        mergeMap((barcode) =>
          this.orderService.confirmOrderItemReceiving(parseInt(barcode))
        ),
        tap(() => {
          this.pageState = this.pageStates.COMPLETE;
        }),
        catchError((err) => {
          this.pageState = this.pageStates.ERROR;
          return throwError(() => new Error());
        })
      )
      .subscribe();
  }
}
